import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_PROMOTED_NICHE_TERRITORY_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/common/hooks/use-promoted-niche-context',
  name: 'Get promoted niche territory',
  message: 'Failed to fetch the territory used to resolve promoted-niche context',
}
